var map = {
	"./bored.json": 90266,
	"./bored3d.json": 91585,
	"./cryptogirls.json": 6449,
	"./goblin.json": 2508,
	"./gorilla.json": 44117,
	"./hopegalaxy1.json": 71881,
	"./junofarming.json": 65753,
	"./junopunks.json": 3661,
	"./junopunks2.json": 70870,
	"./lunatic.json": 42250,
	"./netanots.json": 70062,
	"./old/bored.json": 81210,
	"./old/bored3d.json": 15777,
	"./old/cryptogirls.json": 89991,
	"./old/goblin.json": 33396,
	"./old/gorilla.json": 18603,
	"./old/hopegalaxy1.json": 94005,
	"./old/junofarming.json": 39511,
	"./old/junopunks.json": 49519,
	"./old/junopunks2.json": 95739,
	"./old/netanots.json": 89532,
	"./old/romans.json": 32242,
	"./old/witches.json": 94855,
	"./romans.json": 54448,
	"./witches.json": 64756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12443;